export default "__VITE_ASSET__BYPfvsQq__"